import React from 'react'
import Navbar from '../components/Navbar'
import HomepageComponent from '../components/Homepage'
import Footer from '../components/Footer'
import Scroll from '../components/Utils'

const Homepage = () => {
    return (
        <>
            <Scroll />
            <Navbar />
            <HomepageComponent />
            <Footer />
        </>
    )
}

export default Homepage